export const TIPTAP_EDITOR_SX = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  cursor: 'text',
  '& .ProseMirror': { outline: 'none', minHeight: 240, p: 2 },
  '& .ProseMirror h1': { fontSize: '1.6em', fontWeight: 700, mt: 0 },
  '& .ProseMirror h2': { fontSize: '1.3em', fontWeight: 700 },
  '& .ProseMirror h3': { fontSize: '1.1em', fontWeight: 700 },
  '& .ProseMirror code': {
    background: '#f3f4f6',
    px: 0.5,
    borderRadius: 0.5,
    fontFamily: 'monospace',
    fontSize: 13,
  },
  '& .ProseMirror pre': {
    background: '#f3f4f6',
    p: 1.5,
    borderRadius: 1,
    overflow: 'auto',
  },
  '& .ProseMirror pre code': { background: 'none', p: 0 },
  '& .ProseMirror blockquote': {
    borderLeft: '3px solid #ccc',
    pl: 2,
    color: 'text.secondary',
  },
  '& .ProseMirror ul': { pl: 3 },
  '& .ProseMirror ol': { pl: 3 },
  '& .ProseMirror hr': { border: 'none', borderTop: '2px solid #e0e0e0', my: 2 },
} as const;
